import { getAuth } from "firebase/auth";

/**
 * Makes an authenticated fetch request with Firebase ID token.
 * Automatically adds Authorization header and Content-Type if needed.
 * Throws an error if the user is not authenticated.
 */
export async function authFetch(url, options = {}) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) throw new Error("Not authenticated");

  const token = await user.getIdToken();

  // Merge headers, always set Authorization, set Content-Type for body
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  if (options.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  // Remove undefined headers
  Object.keys(headers).forEach(
    (key) => headers[key] === undefined && delete headers[key]
  );

  return fetch(url, {
    ...options,
    headers,
  });
}